import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

export function getTicketDetails(env, ticketId) {
    return () => {
        return apiCaller
            .call(api.getTicketDetails(env, ticketId))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setTicketDetails - ', error);
                throw error;
            });
    };
}
export function getTicketHistory(env, ticketId, offset, limit) {
    return () => {
        return apiCaller
            .call(api.getTicketHistory(env, ticketId, offset, limit))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setTicketHistory - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Ticket/actions.js